{
  "footer": {
    "alreadyPartner": "Είστε ήδη συνεργάτης;",
    "back": "Πίσω",
    "letsgo": "Πάμε!",
    "login": "Σύνδεση",
    "next": "Επόμενο",
    "readMore": "Μάθε περισσότερα",
    "signUp": "Εγγραφή"
  },
  "formErrors": {
    "address": "Αυτή η διεύθυνση δεν βρέθηκε. Παρακαλώ δοκίμασε κάποια άλλη.",
    "businessName": "Αυτό το όνομα δεν έιναι διαθέσιμο. Παρακαλώ δοκίμασε κάποιο άλλο.",
    "email": "Αυτό το email χρησιμοποιείται ήδη.",
    "verificationCode": "Λάθος κωδικός",
    "turnstileToken": "Ο έλεγχος ασφαλείας απέτυχε. Παρακαλώ δοκιμάστε ξανά."
  },
  "global": {
    "title": "Κάνε εγγραφή στην Treatwell"
  },
  "input": {
    "businessName": {
      "invalid": "Το όνομα στο πεδίο 'Επιχείρηση' είναι πολυ μεγάλο",
      "label": "Όνομα επιχείρησης",
      "required": "Υποχρεωτικό"
    },
    "businessSegment": {
      "aesthetics": "Αισθητική",
      "barber": "Barber",
      "beautician": "Αισθητικός",
      "hair-removal": "Αφαίρεση μαλλιών",
      "hairdresser": "Κομμώτρια/ής",
      "massage": "Μασάζ",
      "nails": "Νύχια",
      "primary": "Βασικό/ή",
      "required": "Παρακαλώ επίλεξε ένα",
      "spa": "Spa"
    },
    "businessType": {
      "dedicatedSpaceCheckbox": "Επιβεβαιώνω οτι έχω ξεχψριστό και συγκεκριμένο χώρο για την εκτέλεση των υπηρεσιών και επαγγελματικό ΑΦΜ",
      "home": "Κατ' οίκον <0>- οι πελάτες έρχονται στο σπίτι σου</0>",
      "mobile": "Χωρίς βάση <0>- επισκέπτεσαι τους πελάτες σου στο χώρο τους</0>",
      "mobileCheckbox": "Θέλω να χρησιμοποιήσω την Treatwell ΜΟΝΟ για διαχείρηση κρατήσεων και ΟΧΙ για online ραντεβού μέσω του marketplace της",
      "mobileMessage": "Δυστυχώς λόγω περιορισμών, το marketplace μας μπορεί να προβάλλει και προωθήσει μόνο επιχειρήσεις που στεγάζονται σε επαγγελματικό χώρο (κατάστημα)",
      "required": "Επέλεξε ένα",
      "shop": "Κατάστημα <0>- οι πελάτες έρχονται στο κατάστημα σου</0>"
    },
    "city": {
      "invalid": "Η λέξη στο πεδίο 'Πόλη' είναι πολύ μεγάλη",
      "label": "Πόλη",
      "required": "Υποχρεωτικό"
    },
    "country": {
      "label": "Χώρα",
      "required": "Υποχρεωτικό"
    },
    "email": {
      "invalid": "Μη έγκυρο",
      "label": "Email",
      "required": "Υποχρεωτικό"
    },
    "firstName": {
      "invalid": "Παρακαλώ μη χρησιμοποιείς ειδικούς χαρακτήρες",
      "label": "Όνομα",
      "required": "Υποχρεωτικό"
    },
    "lastName": {
      "invalid": "Παρακαλώ μη χρησιμοποιείς ειδικούς χαρακτήρες",
      "label": "Επώνυμο",
      "required": "Υποχρεωτικό"
    },
    "marketing": {
      "label": "Θα ήθελα να λαμβάνω επικοινωνίες email με συμβουλές και ιδέες από τους ειδικούς του κλάδου με σκοπό να αναπτύξω την επιχείρηση μου."
    },
    "password": {
      "hint": "Το λιγότερο 8 χαρακτήρες",
      "invalid": "Ο κωδικός απαιτεί τουλάχιστον 8 χαρακτήρες",
      "label": "Κωδικός",
      "required": "Υποχρεωτικό",
      "rules": {
        "error-messages": {
          "password-too-short": "Παρακαλώ εισάγετε τουλάχιστον {{length}} χαρακτήρες.",
          "password-too-long": "Οops! Ο κωδικός πρόσβασής σας δεν μπορεί να είναι μεγαλύτερος από {{length}} χαρακτήρες.",
          "password-needs-uppercase": "Ο κωδικός πρόσβασής σας πρέπει να περιέχει ένα κεφαλαίο γράμμα.",
          "password-needs-lowercase": "Ο κωδικός πρόσβασής σας πρέπει να περιέχει ένα πεζό γράμμα."
        }
      }
    },
    "phoneNumber": {
      "invalid": "Μη έγκυρος αριθμός κινητού",
      "label": "Αριθμός κινητού",
      "required": "Υποχρεωτικό"
    },
    "postalCode": {
      "invalid": "Ο ΤΚ είναι πολύ μεγάλος",
      "label": "Ταχυδρομικός κώδικας",
      "required": "Υποχρεωτικό"
    },
    "privacy": {
      "label": "Κάνοντας εγγραφή στο δωρεάν λογαριασμό της Treatwell , συμφωνείς με την <0>πολιτική απορρήτου</0> και <1>όρους χρήσης</1>"
    },
    "searchBusiness": {
      "label": "Αναζήτηση επιχείρησης"
    },
    "street": {
      "invalid": "Η διεύθυνση είναι πολύ μεγάλη",
      "label": "Διεύθυνση",
      "required": "Υποχρεωτικό"
    }
  },
  "salesMode": {
    "enterPassword": "Πληκτρολόγησε τον κωδικό σου ",
    "invalidPassword": "Λάθος κωδικός"
  },
  "stepContext": {
    "attractNewClients": "Προσελκύστε νέους πελάτες",
    "buildRelationships": "Χτίστε ακόμα καλύτερες σχέσεις με τους πελάτες σας",
    "growBusiness": "Αναπτύξτε την επιχείρησή σας όμορφα",
    "manageAppointments": "Διαχειριστείτε όλα τα ραντεβού σας εν κινήσει",
    "prompt": "Λίγα απλά βήματα (και περίπου 3 λεπτά) σε χωρίζουν από το να γίνεις μέλος σε πάνω από 75.000 καταστήματα που διαχειρίζονται τις επιχειρήσεις τους, αυξάνουν την πελατεία τους και εκτοξεύουν τα έσοδά τους.<br /><br />Με την Treatwell θα μπορείς να:",
    "prompt2": "...και πολλά άλλα",
    "title": "<0>Η εγγραφή σου στην Treatwell</0>, τη μεγαλύτερη πλατφόρμα ομορφιάς στην Ευρώπη, είναι πιο απλή από ποτέ!"
  },
  "stepCounter": {
    "step0": "Βήμα 1",
    "step1": "Βήμα 1",
    "step2": "Βήμα 2",
    "step3": "Βήμα 3",
    "step4": "Βήμα 4",
    "step5": "Συγχαρητήρια"
  },
  "stepEmailVerification": {
    "rateLimited": "Ζήτησες πάρα πολλούς κωδικούς. Χρησιμοποίησε τον κωδικό που σου στείλαμε ήδη με email ή δοκίμασε ξανά σε λίγα λεπτά.",
    "resend": "Ξαναστείλε το",
    "subTitle1": "Παρακαλώ πληκτρολόγησε τον κωδικό που έλαβες",
    "subTitle2": "Δεν έλαβες τον κωδικό;",
    "title": "<0>Σχεδόν τελειώσαμε</0>σου στείλαμε έναν 6ψήφιο αριθμό!"
  },
  "stepError": {
    "accountCreation": "Δημιουργία του λογαριασμού",
    "body": "Αντιμετωπίζουμε προβλήματα.\\nΠαρακαλώ περίμενε ένα λεπτό και ξαναδοκίμασε.",
    "bodyWithError": "Αντιμετωπίζουμε προβλήματα με {{reason}}.\\nΠαρακαλώ περίμενε ένα λεπτό και ξαναδοκίμασε.",
    "button": "Ξαναπροσπάθησε",
    "title": "Ουπς, κάτι πήγε λάθος!"
  },
  "stepFinal": {
    "joke1Punchline": "Γιατι φύσηξε μπαλαγιάζ-ι",
    "joke1Setup": "Γιατι παίρνει ο άνεμος τη μπάλα;",
    "joke2Punchline": "Γιατί είναι των άκρων.",
    "joke2Setup": "Γιατί μια nail artist φωνάζει;",
    "joke3Punchline": "Γιατί ποτέ δεν έβρισκε την άκρη!",
    "joke3Setup": "Γιατί ο κομμωτής δεν έπαιζε κρυφτό;",
    "joke4Punchline": "Γιατι μιλούσε ολη την ωρα πισω απο την πλατη μου.",
    "joke4Setup": "Γιατι θυμωσες με τον κομμωτη σου?",
    "joke5Punchline": "Με ένα γρήγορο κούρεμα!",
    "joke5Setup": "Πως νίκησε ο κομμωτής τον μαραθώνιο;",
    "subTitle": "Μιας που είσαι εδώ, ας σε διασκεδάσουμε με κάποια hair-larious ανέκδοτα!",
    "title": "Ευχαριστούμε, ας ξεκινήσουμε με το στήσιμο της επιχείρησής σου!<br />Δώσε μας <0>δυο λεπτά...</0>"
  },
  "stepFinalRedirectLogin": {
    "alternativeButton": "Εγγραφή",
    "alternativeMessage": "Χρησιμοποιείς την ίδια διεύθυνση για να κάνεις εγγραφή νέας επιχείρησης;",
    "button": "Treatwell Login",
    "message": "<0>Υπέροχα νέα!</0>Η επιχείρηση σου υπάρχει ήδη στην Treatwell."
  },
  "stepFourForm": {
    "prompt1": "Θα χρησιμοποιήσουμε αυτές τις πληροφορίες για να δημιουργήσουμε το λογαριασμό σου και να έρθουμε σε επικοινωνία μαζί σου εάν χρειαστεί.",
    "title": "Πες μας δύο λόγια για εσένα"
  },
  "stepOneForm": {
    "prompt1": "Αναζήτησε ή πληκτρολόγησε το όνομα της επιχείρησής σου",
    "title": "Πες μας δύο λόγια για την επιχείρηση σου."
  },
  "stepOneSearch": {
    "addManually": "Δεν μπορείς να βρεις την επιχείρηση σου; <0>Πληκτρολόγησε το όνομα εδώ</0>",
    "prompt1": "Πληκτρολόγησε το όνομα της επιχείρησής σου",
    "title": "Πες μας για την επιχείρηση σου"
  },
  "stepThreeForm": {
    "title": "Τι είδους επιχείρηση έχεις;"
  },
  "stepTwoForm": {
    "prompt1": "Διάλεξε τις σωστές επιλογές, επέλεξε τις βασικές υπηρεσίες πρώτα",
    "title": "Τι υπηρεσίες προσφέρεις;"
  },
  "stepTurnstile": {
    "title": "Σχεδόν εκεί!",
    "description": "Παρακαλώ ολοκληρώστε τον έλεγχο ασφαλείας για να συνδεθείτε.",
    "loading": "Φόρτωση ελέγχου ασφαλείας…",
    "validationError": "Παρακαλώ ολοκληρώστε τον έλεγχο ασφαλείας"
  }
}
